module.exports = __webpack_public_path__ + "static/media/mlflow.570b8d06.svg";